module.exports = __webpack_public_path__ + "img/team-h-bg.a1495d84.png";